import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button, ListItem, List, Menu } from "@activecollab/components";
import PropTypes from "prop-types";
import { showErrorToast } from "~/components/Toast";
import { usePublicPaymentPayPal } from "~/repository/usePublicPayments";

export const PublicInvoicePaymentResolver = ({ data }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { mutate: payment } = usePublicPaymentPayPal(data?.invoice?.id, "Invoice");
  const onOpen = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onPayPalPayment = useCallback(() => {
    setIsLoading(true);
    setOpen(false);
    payment(null, {
      onSuccess: (r) => {
        if (r?.redirect_url) {
          window.location = r.redirect_url;
        }
      },
      onError: () => {
        setIsLoading(false);
        showErrorToast(t("Unable to connect to PayPal. Please try again."));
      },
    });
  }, [payment, t]);
  return (
    <>
      {data?.accept_credit_card && !data?.accept_paypal && data?.enable_payment ? (
        <Link to={`/s/payment?number=${data?.invoice?.number}&hash=${data?.invoice.hash}`}>
          <Button variant="primary">{t("Pay with Card")}</Button>
        </Link>
      ) : null}
      {!data?.accept_credit_card && data?.accept_paypal && data?.enable_payment ? (
        <Button
          variant="primary"
          onClick={onPayPalPayment}
          disabled={isLoading}
        >
          {t("Pay with PayPal")}
        </Button>
      ) : null}
      {data?.accept_credit_card && data?.accept_paypal && data?.enable_payment ? (
        <Menu
          open={open}
          onClose={onClose}
          target={
            <Button
              onClick={onOpen}
              variant="primary"
              disabled={isLoading}
            >
              {t("Pay Now")}
            </Button>
          }
        >
          <List>
            <Link
              to={`/s/payment?number=${data?.invoice?.number}&hash=${data?.invoice.hash}`}
              className="tw-no-underline"
            >
              <ListItem>{t("Pay with Card")}</ListItem>
            </Link>
            <ListItem onClick={onPayPalPayment}>{t("Pay with PayPal")}</ListItem>
          </List>
        </Menu>
      ) : null}
    </>
  );
};

PublicInvoicePaymentResolver.propTypes = {
  data: PropTypes.object,
};

export default PublicInvoicePaymentResolver;
